import {
  App,
  fullRoutes,
  upstreamProviderSource,
} from "@songtradr-sso/shared/common";
import { redirect } from "@songtradr-sso/shared/frontend";
import { Button, useLoadingSplashOverlay } from "@songtradr/design-language";
import { GoogleIcon, MicrosoftIcon } from "../AuthButtons.Parts";
import { Props, endpoints, text } from "./Upstream.Parts";

export const UpstreamButton = ({ provider }: Props) => {
  const { addLoadingSplash } = useLoadingSplashOverlay();

  const followLink = (url: string) => {
    addLoadingSplash(true);
    redirect(url);
  };

  const labelText =
    provider.customLabel && provider.customLabel.length > 0
      ? provider.customLabel
      : text[provider.source];

  const ProviderIcon = () =>
    provider.source === upstreamProviderSource.enum.GOOGLE ? (
      <GoogleIcon />
    ) : provider.source === upstreamProviderSource.enum.MICROSOFT ? (
      <MicrosoftIcon />
    ) : null;

  return (
    <Button
      $variant="important"
      type="submit"
      onClick={() =>
        followLink(
          `${endpoints.base}/federated/oidc-proxy?upstream=${provider.id}&callback=${fullRoutes[App.Core].oauthCallback}`,
        )
      }
      aria-label={labelText}
    >
      <ProviderIcon />
      {labelText}
    </Button>
  );
};
